export default function NewTabHint() {
  return <span className="sr-only"> (opens in a new tab)</span>;
}
